// voice_ring pipeline: browsers register the '-no-inbound' Twilio identity, so
// the Twilio Device never gets an incoming call and never plays its ringtone.
// CallManager plays the same sound here while a ring prompt is showing.

// The Twilio Voice SDK's own incoming sound (SOUNDS_BASE_URL in its constants)
export const RINGTONE_URL = 'https://sdk.twilio.com/js/client/sounds/releases/1.0.0/incoming.mp3';

const GESTURE_EVENTS = ['pointerdown', 'keydown'] as const;

let audio: HTMLAudioElement | null = null;
let ringing = false;
let muted = false;
let waitingForGesture = false;

const getAudio = () => {
  if (!audio) {
    audio = new Audio(RINGTONE_URL);
    audio.loop = true;
  }
  return audio;
};

const pause = () => {
  if (!audio) return;
  audio.pause();
  audio.currentTime = 0;
};

const stopWaitingForGesture = () => {
  if (!waitingForGesture) return;
  waitingForGesture = false;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  GESTURE_EVENTS.forEach((event) => window.removeEventListener(event, onGesture, true));
};

const play = () => {
  if (!ringing || muted) return;
  getAudio().play().catch((err: DOMException) => {
    // Autoplay is blocked until the page gets a user gesture (e.g. a ring
    // arriving right after a reload): start on the next click or key press
    if (err?.name !== 'NotAllowedError') {
      console.error(err);
      return;
    }
    if (waitingForGesture) return;
    waitingForGesture = true;
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    GESTURE_EVENTS.forEach((event) => window.addEventListener(event, onGesture, true));
  });
};

function onGesture() {
  stopWaitingForGesture();
  play();
}

export const start = () => {
  if (ringing) return;
  ringing = true;
  play();
};

export const stop = () => {
  ringing = false;
  stopWaitingForGesture();
  pause();
};

// Follows the same mute as the Twilio Device's ringtone (user audio setting and
// snooze, see muteIncomingCalls)
export const setMuted = (value: boolean) => {
  muted = value;
  if (muted) {
    stopWaitingForGesture();
    pause();
  } else {
    play();
  }
};
